// Las fotos subidas desde el panel se guardan como ruta del Worker
// (/api/media/...), no como URL completa, para que no dependan del dominio.
export const mediaUrl = (valor, reserva) =>
  !valor ? reserva : valor.startsWith("http") ? valor : `${process.env.REACT_APP_BACKEND_URL}${valor}`;
